import { render, staticRenderFns } from "./LogoMasterIcon.vue?vue&type=template&id=46195734&"
import script from "./LogoMasterIcon.vue?vue&type=script&lang=js&"
export * from "./LogoMasterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports